import React, { useState } from "react";
import remove from "lodash/remove";

import { withSelectedCars } from "../../../shared/containers/containerSelectedCars";
import { withSelectedReports } from "../../../shared/containers/containerSelectedReports";

import CarsListReportItem from "../cars/carsListReportItem";
import { getColor } from "./static.reportsColors";

import styles from "./carsListReportsItems.module.scss";

const changeReportCar = (props, car) => {
  const { selectedCars, onChangeSelectedCar } = props;
  let chooseList = [...selectedCars];
  let isSelected = chooseList.find((item) => item.id === car.id);

  if (!isSelected) {
    let itemColor = getColor(chooseList);

    chooseList.push({
      id: car.id,
      title: car.unit.title,
      registerNumber: car.unit.registerNumber,
      color: itemColor,
      reports: car.reports,
    });

    onChangeSelectedCar(chooseList);
  } else {
    remove(chooseList, (item) => {
      return item.id === car.id;
    });

    onChangeSelectedCar(chooseList);
  }
};

const CarsListReportsItems = (props) => {
  const { data, selectedCars, handleScrollTo, selectedReports } = props;
  const [activeInfoCarId, setActiveInfoCar] = useState("");
  const changeActiveInfoCar = (id) => {
    activeInfoCarId !== id ? setActiveInfoCar(id) : setActiveInfoCar("");
  };

  const selectedReport = selectedReports.length === 0 ? null : selectedReports[0];

  return (
    <div className={styles.carsList}>
      {data.map((item) => {
        let isChecked = selectedCars.find((car) => car.id === item.id) !== undefined;

        if (
          selectedReport &&
          !item.reports.some((x) => {
            return x.id === selectedReport.id;
          })
        ) {
          return null;
        }

        return (
          <div
            className={`${styles.container_carListItemWrapper} ${
              activeInfoCarId === item.id ? "selected_container_carsListItemWrapper" : ""
            }`}
            key={item.id}
          >
            <CarsListReportItem
              data={item}
              changeActiveInfoCar={changeActiveInfoCar.bind(this, item.id)}
              checked={isChecked}
              selected={activeInfoCarId === item.id}
              changeReportCar={changeReportCar.bind(this, props, item)}
              handleScrollTo={handleScrollTo}
            />
          </div>
        );
      })}
    </div>
  );
};

export default withSelectedReports(withSelectedCars(CarsListReportsItems));
